<template>
  <div class="mobile-app-qr-code">
    <!--    <qrcode-svg :value="getUrl" :size="300" level="H" class="mobile-app-qr-code_img" />-->

    <qrcode-vue :value="getUrl" :size="170" level="H" render-as="svg" />
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'

export default {
  components: { QrcodeVue },
  props: {
    platform: {
      type: String,
      default: 'apple',
    },
  },
  computed: {
    getUrl () {
      switch (this.platform) {
        case 'apple': return this.$store.state.mobileApp.appStoreLink
        case 'gplay': return this.$store.state.mobileApp.googlePlayLink
        case 'rustore': return this.$store.state.mobileApp.ruStoreLink
        default: return this.$store.state.mobileApp.googlePlayLink
      }
    },
  },
}
</script>

<style lang="less">
.mobile-app-qr-code {
  display: inline-block;

  &_img {
    width: 100%;

    /*@media screen and (max-width: 1200px) {
      height: 35px;
    }*/
  }
}
</style>
